import { DescribeDrawing, PleaseDescribe } from "./DescribeDrawingF.jsx";
import { DrawDescription } from "./DrawDescriptionF.jsx";
import { WaitingTask } from "./WaitingTaskF.jsx";
import { InitialDescription } from "./InitialDescriptionF.jsx";

const InitialPrompt = () => {
  return <>
    <InitialDescription {...{fontSize: '3xl'}} />
    <PleaseDescribe />
  </>
}

export { DrawDescription, DescribeDrawing, WaitingTask, InitialPrompt }
